module.exports = __webpack_public_path__ + "img/lifecoach.bd2f16b6.jpg";